import { render, staticRenderFns } from "./UserCopyModal.vue?vue&type=template&id=1c38a280&"
import script from "./UserCopyModal.vue?vue&type=script&lang=ts&"
export * from "./UserCopyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports